module.exports = __webpack_public_path__ + "img/choice.61b39425.png";